import $ from 'jquery';
import { debounce } from 'underscore';
import { mediaHeader } from '../../media-header';

import { TimelineLite, gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import 'slick-carousel';

$(document).ready(() => {
	const slickSlider = mediaHeader.slickSlider;
	const splitTextTimeline = [];
	const win = $(window);
	const mediaHeaderMobileWrapper = $('.atl-media-header-mobile-wrapper-js');
	const mediaHeaderDesktopWrapper = $('.atl-media-header-desktop-wrapper-js');
	const eyeCatcher = $('.atl-media-header .overlay-text-eyecatcher-container');

	function moveHeaderText() {
		$('.overlay-text').each((index, element) => {
			const distanceToRightScreenBorder =
				$(window).width() -
				($(element).offset().left +
					$(element).width() +
					Number.parseInt($(element).css('margin-right')));
			if (distanceToRightScreenBorder < 180 && $(window).width() > 992) {
				const margin = 180 - distanceToRightScreenBorder;
				$(element).css('margin-right', `${margin}px`);
			} else {
				$(element).css('margin-right', 0);
			}
		});
	}

	function reposition(window) {
		const mediaHeaderDOM = $('.atl_media_header');
		if (mediaHeaderDOM.length) {
			if (window.width() < 992) {
				if (mediaHeaderMobileWrapper.children().length === 0) {
					mediaHeaderDOM.appendTo(mediaHeaderMobileWrapper);
				}
			} else {
				if (mediaHeaderDesktopWrapper.children().length === 0) {
					mediaHeaderDOM.appendTo(mediaHeaderDesktopWrapper);
				}
			}

			slickSlider.slick('reinit');
			moveHeaderText();
		}
	}

	function initTextAnimation(slickSliderElement, currentSlide) {
		const currentSlideObj = slickSliderElement.find(
			`[data-slick-index="${currentSlide}"]`,
		);
		const $headingOverlayText = currentSlideObj.find('.overlay-text');
		const $headingInner = $headingOverlayText.find('.text > *');

		// Start overlay-text Animation
		$headingOverlayText.addClass('fadeIn');

		// Init Text-Animation
		splitTextTimeline[currentSlide] = new TimelineLite({ paused: true });
		gsap.registerPlugin(CustomEase);
		CustomEase.create(
			'customEase',
			'M0,0 C0.2,0 0.337,0.566 0.47,0.772 0.615,0.998 0.822,1 1,1',
		);
		$headingInner.wrapInner("<div class='line-inner'></div>");
		splitTextTimeline[currentSlide].staggerTo(
			$headingOverlayText.find('.line-inner'),
			0.75,
			{
				y: 0,
				force3D: true,
				ease: 'customEase',
			},
			0.15,
		);

		return splitTextTimeline[currentSlide];
	}

	function initVideo() {
		let atStart = true;
		let timer;
		let startingWidth;
		const videoContainer = $('.atl_media_header video');
		const videoObject = videoContainer[0];
		const playPauseButton = $('.atl_media_header button.play-pause-button');
		window.addEventListener('resize', stopVideoAfterResize());

		function stopVideoAfterResize() {
			return () => {
				if (atStart) {
					startingWidth = $(window).width();
					atStart = false;
				}

				if (timer) {
					clearTimeout(timer);
				}
				timer = setTimeout(atEnd, 500);
			};
		}

		function atEnd() {
			if (startingWidth >= 992 && $(window).width() < 992) {
				videoObject.pause();
				playPauseButton.removeClass('play');
			} else if (startingWidth < 992 && $(window).width() >= 992) {
				videoObject.play();
				playPauseButton.addClass('play');
			}
			startingWidth = null;
			atStart = true;
		}
	}

	// TextAnimation first slide
	splitTextTimeline[0] = initTextAnimation(slickSlider, 0);
	splitTextTimeline[0].play();

	// On before slide change
	slickSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
		const currentSlideObj = $(event.target).find(
			`[data-slick-index="${currentSlide}"]`,
		);

		// Reset overlay-text Animation
		const $headingOverlayText = currentSlideObj.find('.overlay-text');
		$headingOverlayText.removeClass('fadeIn');

		const nextSlideObj = $(event.target).find(
			`[data-slick-index="${nextSlide}"]`,
		);
		if (typeof splitTextTimeline[nextSlide] === 'undefined') {
			// Init Animation
			splitTextTimeline[nextSlide] = initTextAnimation(
				$(event.target),
				nextSlide,
			);
		} else {
			// Start overlay-text Animation
			nextSlideObj.find('.overlay-text').addClass('fadeIn');
		}

		// Restart Animation
		nextSlideObj.find('.line-inner').removeAttr('style'); // Reset Animation
		const animationTimeout = setTimeout(() => {
			splitTextTimeline[nextSlide].time(0);
			splitTextTimeline[nextSlide].play(0);
			clearTimeout(animationTimeout);
		}, 500);
	});

	if ($('.atl_media_header video').length) {
		initVideo();
	}

	function adjustHeight() {
		const picture = $('.atl-media-header picture');
		if ($(window).width() < 992 && eyeCatcher.length) {
			const height = eyeCatcher.height();
			const headerHeight = height + 250;
			if (picture.height() < headerHeight) {
				picture.css('height', `${headerHeight}px`);
			}
		} else {
			picture.css('height', '');
		}
	}

	adjustHeight();

	win.resize(
		debounce(() => {
			reposition(win);
			adjustHeight();
		}, 250),
	);

	reposition(win);
});
